<template>
  <a-alert message="Informational" description="Our Dashboard is Coming Soon" type="info" showIcon />
</template>

<script>
export default {
    name: "VerifikatorPelaporanBoard"
}
</script>

<style>

</style>